import React from "react";

export default function Privacy() {
  return (
    <section className="terms">
      <div className="auto__container">
        <div className="terms__inner">
          <div className="terms__inner-title">
            <p className="sm">Proxium</p>
            <h3>Privacy Policy</h3>
            <p className="sm">Last Updated: April 9th, 2024</p>
          </div>
          <div className="terms__inner-text">
            Introduction
            <br />
            Proxium and its subsidiaries ("Proxium" "we," or "us") owns and operates
            websites (the "Websites") located at <u> www.Proxium.com</u> and may
            have previously, now or in the future own and/or operate a Hims
            and/or Hers mobile application (collectively, the " Platform"). Your
            access and use of the Platform, any part thereof, or anything
            associated therewith, including its content ("Content"), any
            products or services provided through the Platform or otherwise by
            Proxium, and any affiliated website, software or application owned or
            operated by Proxium (collectively, including the Platform and the
            Content, the "Service") are subject to tProxiumPrivacy Policy unless
            specifically stated otherwise. Capitalized terms not otherwise
            defined in tProxiumPrivacy Policy have the same meaning as set forth
            in the Proxium Terms and Conditions ("Terms and Conditions").
            <br />
            We are committed to respecting the privacy of users of the Service.
            We created tProxiumPrivacy Policy ( "Privacy Policy" ) to tell you how
            Proxium collects, uses and discloses information in order to provide
            you with the Service.
            <br />
            By creating, registering, or logging into an account through the
            Service, or otherwise accessing or using the Service, you are
            acknowledging the most recent version of tProxiumPrivacy Policy. If we
            make any changes to our Privacy Policy, we will post the revised
            Privacy Policy and update the "Last updated" date of the Privacy
            Policy.
            <br />
            If you are using the Service on behalf of an individual other than
            yourself, you represent that you are authorized by such individual
            to act on such individual's behalf and that such individual
            acknowledges the practices and policies outlined in tProxiumPrivacy
            Policy.
            <br />
            Limitations on Use by Minors
            <br />
            Our Service is generally intended for use by individuals who are at
            least eighteen (18) years of age or such older age as may be
            required by applicable state laws in the jurisdiction in which an
            individual utilizes the Service. Individuals who are between the
            ages of thirteen (13) and eighteen (18) (or such older age of
            majority) may use the Service for the sole purpose of obtaining a
            medical consultation for the treatment of acne using topical
            skincare products (to the extent made available) if a parent or
            legal guardian provides consent to such use in accordance with the
            requirements set forth in our Terms and Conditions and the Service.
            The Service is not designed or intended to attract, and is not
            directed to, children under thirteen (13) years of age. If we obtain
            actual knowledge that we have collected personal information through
            the Platform from a person under thirteen (13) years of age, we will
            use reasonable efforts to refrain from further using such personal
            information or maintaining it in retrievable form.
            <br />
            Furthermore, if you are under sixteen (16) years of age, then you
            (or your parent or legal guardian if you are under age 13) may at
            any time request that we remove content or information about you
            that is posted on the Platform. Please submit any such request
            ("Request for Removal of Minor Information") to either of the
            following:
            <ul>
              <li>
                By mail: Proxium , Attn: Privacy Officer, 2269 Chestnut Street,
                #523, San Francisco, CA 94123, with a subject line of "Removal
                of Minor Information. If you send by mail, please send by U.S.
                Certified Mail, Return Receipt Requested to allow for
                confirmation of mailing, delivery and tracking.
              </li>
              <li>
                By email: <u>privacy@forhims.com</u>, with a subject line of
                "Removal of Minor Information"
              </li>
            </ul>
            <br />
            For each Request for Removal of Minor Information, please state
            "Removal of Minor Information" in the email or letter subject line,
            and clearly state the following in the body of the request:
            <ul>
              <li>The nature of your request</li>
              <li>The identity of the content or information to be removed</li>
              <li>
                The location of the content or information on the Platform (e.g.
                by providing the URL)
              </li>
              <li>
                That the request is related to the "Removal of Minor
                Information"
              </li>
              <li>
                Your name, street address, city, state, zip code and email
                address, and whether you prefer to receive a response to your
                request by mail or email
              </li>
            </ul>
            We will not accept any Request for Removal of Minor Information via
            telephone or facsimile. Proxium is not responsible for failing to
            comply with any Request for Removal of Minor Information that is
            incomplete, incorrectly labeled or incorrectly sent.
            <br />
            Please note that we are not required to erase or otherwise
            eliminate, or enable erasure or elimination of such content or
            information in certain circumstances, such as, for example, when an
            international, federal, state, or local law, rule or regulation
            requires Proxium to maintain the content or information; when Proxium
            maintains the content or information on behalf of your Providers (as
            defined in our Terms and Conditions) as part of your electronic
            medical record; when the content or information is stored on or
            posted to the Site by a third party other than you (including any
            content or information posted by you that was stored, republished or
            reposted by the third party); when Proxium anonymizes the content or
            information, so that you cannot be individually identified; when you
            do not follow the aforementioned instructions for requesting the
            removal of the content or information; and when you have received
            compensation or other consideration for providing the content or
            information.
            <br />
            The foregoing is a description of Proxium' voluntary practices
            concerning the collection of personal information through the
            Service from certain minors, and is not intended to be an admission
            that Proxium is subject to the Children's Online Privacy Protection
            Act, the Federal Trade Commission's Children's Online Privacy
            Protection Rule(s), or any similar international, federal, state, or
            local laws, rules, or regulations.
            <br />
            Protected Health Information
            <br />
            When you set up an account with Proxium, you are creating a direct
            customer relationship with Proxium that enables you to access and/or
            utilize the various functions of the Platform and the Service as a
            user. As part of that relationship, you provide information to
            Proxium, including but not limited to, your name, email address,
            shipping address, phone number and certain transactional
            information, that we do not consider to be "protected health
            information" or "medical information".
            <br />
            However, in using certain components of the Service, you may also
            provide certain health or medical information that may be protected
            under applicable laws. Proxium is not a "covered entity" under the
            Health Insurance Portability and Accountability Act of 1996, Public
            Law 104-191, and its related regulations and amendments from time to
            time (collectively, " HIPAA"). One or more of the Labs, Pharmacies
            or Medical Groups (as defined in our Terms and Conditions) may or
            may not be a "covered entity" or "business associate" under HIPAA,
            and Proxium may in some cases be a "business associate" of a Pharmacy
            or Medical Group. It is important to note that HIPAA does not
            necessarily apply to an entity or person simply because there is
            health information involved, and HIPAA may not apply to your
            transactions or communications with Proxium, the Medical Groups, the
            Providers, the Labs, or the Pharmacies. To the extent Proxium is
            deemed a "business associate" however, and solely in its role as a
            business associate, Proxium, may be subject to certain provisions of
            HIPAA with respect to "protected health information," as defined
            under HIPAA, that you provide to Proxium, the Medical Group or the
            Providers (" PHI"). In addition, any medical or health information
            that you provide that is subject to specific protections under
            applicable state laws (collectively, with PHI, "Protected
            Information" ), will be used and disclosed only in accordance with
            such applicable laws. However, any information that does not
            constitute Protected Information under applicable laws may be used
            or disclosed in any manner permitted under tProxiumPrivacy Policy.
            Protected Information does not include information that has been
            de-identified in accordance with applicable laws.
            <br />
            The Medical Groups and Providers have adopted a
            <u>Notice of Privacy Practices</u> that describes how they use and
            disclose Protected Information. By accessing or using any part of
            the Service, you acknowledge receipt of the Notice of Privacy
            Practices from your Medical Group and Provider(s).
            <br />
            By accessing or using any part of the Service, you understand that
            even if HIPAA does apply to Proxium, the Medical Groups, the
            Providers, the Labs, or the Pharmacies, any information that you
            submit to Proxium that is not intended and used solely for the
            provision of diagnosis and treatment by the Medical Group and
            Providers, laboratory services by the Labs or prescription
            fulfillment by the Pharmacies, is not considered Protected
            Information, and will only be subject to our Privacy Policy and any
            applicable state laws that govern the privacy and security of such
            information. For purposes of clarity, information you provide to
            Proxium in order to register and set up an account on the Platform,
            including name, username, email address, shipping address and phone
            number, are not considered Protected Information.
            <br />
            Collection of Personal Information
            <br />
            The personal data we collect depends on how you interact with us,
            the services you use, and the choices you make.
            <br />
            We collect information about you from different sources and in
            various ways when you use our services, including information you
            provide directly, information collected automatically, information
            from third-party data sources, and data we infer or generate from
            other data.
            <br />
            Information you provide directly. We collect personal data you
            provide to us. For example:
            <ul>
              <li>
                Name and contact information, such as your name, email address,
                phone number, and billing and physical addresses.
              </li>
              <li>
                Demographic data, such as your gender, date of birth, and zip
                code.
              </li>
              <li>
                Third-party website, network, platform, server and/or
                application information (e.g., Facebook, Twitter, Instagram)
              </li>
              <li>
                Payment information, such as your credit card number, financial
                account information, and other payment details.
              </li>
              <li>
                Content and files, such as photographs, videos, documents, and
                other files you upload to our Service. TProxiumincludes email
                messages and other communications you send to us.
              </li>
              <li>Sensitive personal pnformation</li>
              <ul>
                <li>
                  Government ID. We may collect government-issued identifiers
                  such as driver’s license, passport number, and social security
                  numbers.
                </li>
                <li>
                  Photographic or video images submitted for identification or
                  non-diagnosis or treatment purposes, including photographs of
                  your driver’s license or passport
                </li>
                <li>
                  Account access information. We collect information such as a
                  username or account number in combination with a password,
                  security or access code, or other credential that allows
                  access to an account.
                </li>
                <li>
                  Sensitive demographic data. We collect information about
                  racial or ethnic origin.
                </li>
                <li>
                  Contents of communications. We collect the contents of
                  communications that you make via our Service.
                </li>

                <li>
                  Biometric information. We or our service providers may use
                  biometric information to verify your identity prior to your
                  use of our Service.
                </li>
                <li>
                  Health data. We collect and analyze information concerning
                  your health.
                </li>
                <li>
                  Sexuality. We collect and analyze information about your sex
                  life or sexual orientation.
                </li>
              </ul>
            </ul>
            Information we collect automatically. When you use our services, we
            collect some information automatically. For example:
            <ul>
              <li>
                Identifiers and device information. When you visit our websites,
                our web servers automatically log your Internet Protocol (IP)
                address and information about your device, including device
                identifiers (such as MAC address); device type; and your
                device’s operating system, browser, and other software including
                type, version, language, settings, and configuration. As further
                described in the “Cookies, Mobile IDs, and Similar Technologies”
                section below, our websites and online services store and
                retrieve cookie identifiers, mobile IDs, and other data.
              </li>
              <li>
                Geolocation data. Depending on your device and app settings, we
                collect geolocation data when you use our apps or online
                services. TProxiuminformation may include precise geolocation
                data, meaning data derived from a device and that is used to
                locate you within a circle with a radius of 1,850 feet or less,
                which is considered a type of sensitive personal information.
              </li>
              <li>
                Usage data. We automatically log your activity on our websites,
                apps and connected products, including the URL of the website
                from which you came to our sites, pages you viewed, how long you
                spent on a page, access times, and other details about your use
                of and actions on our website. In some instances, such usage
                data may be sensitive personal information if it relates to
                browsing activity on health-specific sites.
              </li>
            </ul>
            Information we create or generate. We infer new information from
            other data we collect, including using automated means to generate
            information about your likely preferences or other characteristics
            (“inferences”). For example, we infer your general geographic
            location (such as city, state, and country) based on your IP
            address.
            <br />
            Information we obtain from third-party sources. We also obtain the
            types of information described above from third parties. These
            third-party sources include, for example:
            <ul>
              <li>
                Third-party partners.  Third-party applications and services,
                including social networks you choose to connect with or interact
                with through our services.
              </li>
              <li>
                Co-branding/marketing partners.  Partners with which we offer
                co-branded services or engage in joint marketing activities.
              </li>
              <li>
                Service providers.  Third parties that collect or provide data
                in connection with work they do on our behalf, for example
                companies that determine your device’s location based on its IP
                address.
              </li>
              <li>
                Publicly available sources.  Public sources of information such
                as open government databases.
              </li>
            </ul>
            When you are asked to provide personal data, you may decline. And
            you may use web browser or operating system controls to prevent
            certain types of automatic data collection. But if you choose not to
            provide or allow information that is necessary for certain services
            or features, those services or features may not be available or
            fully functional.
            <br />
            Proxium Health provides management services to the medical providers
            and certain pharmacies you may access through our Service. As a
            result, we may store additional health information on their behalf,
            including your medical record, communications with providers, and
            medical history.
            <br />
            Cookies, Mobile IDs, and Similar Technologies
            <br />
            We use cookies, web beacons, mobile analytics and advertising IDs,
            and similar technologies to operate our websites and online services
            and to help collect data, including usage data, identifiers, and
            device information.
            <br />
            What are cookies and similar technologies?
            <br />
            Cookies are small text files placed by a website and stored by your
            browser on your device. A cookie can later be read when your browser
            connects to a web server in the same domain that placed the cookie.
            The text in a cookie contains a string of numbers and letters that
            may uniquely identify your device and can contain other information
            as well. TProxiumallows the web server to recognize your browser over
            time, each time it connects to that web server.
            <br />
            Web beacons are electronic images (also called single-pixel or clear
            GIFs) that are contained within a website or email. When your
            browser opens a webpage or email that contains a web beacon, it
            automatically connects to the web server that hosts the image
            (typically operated by a third party). TProxiumallows that web server
            to log information about your device and to set and read its own
            cookies. In the same way, third-party content on our websites (such
            as embedded videos, plug-ins, or ads) results in your browser
            connecting to the third-party web server that hosts that content. We
            also include web beacons in our email messages or newsletters to
            tell us if you open and act on them.
            <br />
            Mobile analytics and advertising IDs are generated by operating
            systems for mobile devices (iOS and Android) and can be accessed and
            used by apps in much the same way that websites access and use
            cookies. Our apps contain software that enables us and our
            third-party analytics and advertising partners to access these
            mobile IDs.
            <br />
            How do we and our partners use cookies and similar technologies?
            <br />
            We, and our analytics and advertising partners, use these
            technologies in our websites, apps, and online services to collect
            personal data (such as the pages you visit, the links you click on,
            and similar usage information, identifiers, and device information)
            when you use our services, including personal data about your online
            activities over time and across different websites or online
            services. TProxiumdata is used to store your preferences and settings,
            enable you to sign-in, analyze how our websites and apps perform,
            track your interaction with the site or app, develop inferences,
            deliver and tailor interest-based advertising, combat fraud, and
            fulfill other legitimate purposes. We and/or our partners also share
            the data we collect or infer with third parties for these purposes.
            For more information about the third-party analytics and advertising
            partners that collect personal information on our services, please
            see the “Our Disclosure of Personal Data” section of
            tProxiumstatement.
            <br />
            What controls are available?
            <br />
            There are a range of cookie and related controls available through
            browsers, mobile operating systems, and elsewhere. See the “Choice
            and Control of Personal Data” section below for details.
            <br />
            Use of Information
            <br />
            We use the personal data we collect for purposes described in
            tProxiumprivacy statement or as otherwise disclosed to you, subject to
            the limitations addressed in the Protected Health Information
            Section above. For example, we use personal data for the following
            purposes:
            <br />
            Purpose of UseCategories of Personal DataProduct and service
            delivery. To provide and deliver our Service, including
            troubleshooting, facilitating your movement through the Service,
            confirming your location, improving, and personalizing those
            services.Contact information, demographic data, payment information,
            content and files, biometric information, identifiers and device
            information, geolocation data, usage data, inferences <br /> <br />{" "}
            Sensitive information: government ID, account access information,
            sensitive demographic data, contents of communications, biometric
            information for identification, health data for collecting and
            analyzing, information about sex life or sexual orientation for
            collecting and analyzing.Business operations. To operate our
            business, such as billing, processing your payments, accounting,
            administering your account, improving our internal operations,
            securing our systems, detecting fraudulent or illegal activity,
            verifying your identity, and meeting our legal obligations.
            Additionally, to protect or enforce Proxium' rights and
            properties.Contact information, demographic data, payment
            information, content and files, biometric information, identifiers
            and device information geolocation data, usage data, inferences{" "}
            <br /> <br /> Sensitive information: government ID, account access
            information, precise geolocation data, sensitive demographic data,
            contents of communications, genetic data, biometric information for
            identification, health data for collecting and analyzing,
            information about sex life or sexual orientation for collecting and
            analyzing.Product improvement, development, and research. To
            develop, test, or improve the Service and content, features and/or
            products or services offered via the Service. Additionally, to
            Identify or create new products or services. Lastly, to analyze
            traffic and user behavior or activity to and through ServiceContact
            information, demographic data, payment information, content and
            files, biometric information, identifiers and device information,
            geolocation data, usage data, inferences <br /> <br /> Sensitive
            information: government ID, account access information, precise
            geolocation data, sensitive demographic data, contents of
            communications, genetic data, biometric information for
            identification, health data for collecting and analyzing,
            information about sex life or sexual orientation for collecting and
            analyzingPersonalization. To understand you and your preferences to
            enhance your experience and enjoyment using our services.Contact
            information, demographic data, payment information, content and
            files, biometric information, identifiers and device information
            geolocation data, usage data, inferences <br /> <br /> Sensitive
            information: government ID, account access information, precise
            geolocation data, sensitive demographic data, contents of
            communications, genetic data, biometric information for
            identification, health data for collecting and analyzing,
            information about sex life or sexual orientation for collecting and
            analyzing.Customer support. To provide customer support, fulfill
            your requests, and respond to your questions. Additionally, to place
            and track orders for products or services on your behalfContact
            information, demographic data, payment information, content and
            files, biometric information, identifiers and device information
            geolocation data, usage data, inferences <br /> <br /> Sensitive
            information: government ID, account access information, precise
            geolocation data, sensitive demographic data, contents of
            communications, genetic data, biometric information for
            identification, health data for collecting and analyzing,
            information about sex life or sexual orientation for collecting and
            analyzing.Communications. To send you information about Proxium, the
            Labs, the Pharmacies, the Medical Groups, the Providers, including
            confirmations, invoices, technical notices, updates, security
            alerts, and support and administrative messages. Additionally, to
            communicate with you by letter, email, text, telephone, or other
            forms of communication, including on behalf of your Provider(s), to
            facilitate telehealth ServiceContact information, demographic data,
            payment information, content and files, biometric information,
            identifiers and device information geolocation data, usage data,
            inferences <br /> <br /> Sensitive information: government ID,
            account access information, precise geolocation data, sensitive
            demographic data, contents of communications, genetic data,
            biometric information for identification, health data for collecting
            and analyzing, information about sex life or sexual orientation for
            collecting and analyzing.Marketing. To communicate with you about
            new services, offers, promotions, rewards, contests, upcoming
            events, and other information about our services and those of our
            selected partners.Contact information, demographic data, payment
            information, content and files, biometric information, identifiers
            and device information geolocation data, usage data, sensor data,
            inferences <br /> <br /> Sensitive information: health data for
            collecting and analyzingAdvertising. To promote and market Proxium,
            the Service, and the products and/or services offered via the
            ServiceContact information, demographic data, identifiers and device
            information, geolocation data, usage data, inferences <br /> <br />{" "}
            Sensitive information: health data for collecting and analyzing
            <br />
            Additionally, we may use your browsing and other activity on the
            Service to promote and market Proxium, the Service, and the products
            and/or services offered via the Service, as well as to measure our
            advertising and marketing efforts. Depending on your activity on the
            Service, tProxiummay include information related to you visiting
            health-related pages on the Service. In some states, we may be
            required to obtain your consent prior to using information that
            constitutes sensitive personal information. While we may use
            information about your browsing activity on health-related pages, we
            do not use Protected Information for advertising or marketing.
            <br />
            We may de-identify your information and use, create and sell such
            de-identified information or any business or other purpose not
            prohibited by applicable law.
            <br />
            Disclosure of Information
            <br />
            We disclose personal data with your consent or as we determine
            necessary to complete your transactions or provide the services you
            have requested or authorized. Subject to the limitations described
            in the Protected Health Information section above, we may disclose
            your information to third parties in connection with the provision
            of our Service or as otherwise permitted or required by law. For
            example, we may disclose your information to:
            <ul>
              <li>
                Service providers. We provide personal data to vendors or agents
                working on our behalf for the purposes described in
                tProxiumstatement. For example, companies we’ve hired to provide
                customer service support or assist in protecting and securing
                our systems and services may need access to personal data to
                provide those functions.
              </li>
              <li>
                Financial services & payment processing. When you provide
                payment data, for example to make a purchase, we will disclose
                payment and transactional data to banks and other entities as
                necessary for payment processing, fraud prevention, credit risk
                reduction, analytics, or other related financial services.
              </li>
              <li>
                Marketing/Ad Partners. We may provide personal data to marketing
                and advertising partners. For example, we may share identifying
                information with an advertising partner in order to deliver
                personalized advertising to you or for the purpose of delivering
                advertisements to other people with similar interests to you.
                TProxiummay include sensitive personal information such as health
                data or information about your sex life to the extent it is not
                Protected Health Information. For example, if you view a webpage
                about balding or erectile dysfunction treatments, we may provide
                that information to an advertising partner who will then deliver
                advertisements to you on different websites based on your
                viewing activity.
              </li>
              <li>
                Financial services & payment processing. When you provide
                payment data, for example to make a purchase, we will disclose
                payment and transactional data to banks and other entities as
                necessary for payment processing, fraud prevention, credit risk
                reduction, analytics, or other related financial services.
              </li>
              <li>
                Affiliates. We enable access to personal data across our
                subsidiaries, affiliates, and related companies, for example,
                where we share common data systems or where access helps us to
                provide our services and operate our business.
              </li>
              <li>
                The Labs, Pharmacies, Medical Groups, or their Providers. We
                facilitate information sharing between you and the Medical
                Groups, Pharmacies, Providers, and Labs, as applicable, to
                enable them to provide services to you via the Service and to
                collect payment on their behalf.
              </li>
              <li>
                Corporate transactions. We may disclose personal data as part of
                a corporate transaction or proceeding such as a merger,
                financing, acquisition, bankruptcy, dissolution, or a transfer,
                divestiture, or sale of all or a portion of our business or
                assets.
              </li>
              <li>
                Legal and law enforcement. We will access, disclose, and
                preserve personal data when we believe that doing so is
                necessary to comply with applicable law or respond to valid
                legal process, including from law enforcement or other
                government agencies.
              </li>
              <li>
                Security, safety, and protecting rights. We will disclose
                personal data if we believe it is necessary to:
              </li>
              <ul>
                <li>
                  protect our customers and others, for example to prevent spam
                  or attempts to commit fraud, or to help prevent the loss of
                  life or serious injury of anyone;
                </li>
                <li>
                  operate and maintain the security of our services, including
                  to prevent or stop an attack on our computer systems or
                  networks; or
                </li>
                <li>
                  protect the rights or property of ourselves or others,
                  including enforcing our agreements, terms, and policies.
                </li>
              </ul>
            </ul>
            Third party analytics and advertising companies also collect
            personal data through our website and apps including identifiers and
            device information (such as cookie IDs, device IDs, and IP address),
            geolocation data, usage data, and inferences based on and associated
            with that data, as described in the “Cookies” section of
            tProxiumstatement. These third-party vendors may combine tProxiumdata
            across multiple sites to improve analytics for their own purpose and
            others. For example, we use Google Analytics on our website to help
            us understand how users interact with our website; you can learn how
            Google collects and uses information at
            <u>
              www.google.com/policies/privacy/partners.
              <br />
            </u>
            Other third-party analytics and advertising providers we use on our
            websites include, for example:
            <br />
            Company/Service Purpose(s) Privacy NoticesManage Settings
            (opt-out) Google (DoubleClick) Advertising, analytics
            <u>https://policies.google.com/technologies/partner-sites</u>
            <u>https://adssettings.google.com/</u> Twitter
            AdvertisingAdvertising
            <u>
              https://twitter.com/en/privacyhttps://help.twitter.com/en/safety-and-security/privacy-controls-for-tailored-ads
            </u>
            Facebook Audiences Advertising
            <u>
              https://www.facebook.com/privacy/explanationhttps://www.facebook.com/settings?tab=ads
            </u>
            Google Analytics Analytics
            <u>www.google.com/policies/privacy/partners</u>
            <u>
              https://tools.google.com/dlpage/gaoptout
              <br />
            </u>
            Some of the data disclosures to these third parties may be
            considered a “sale” or “sharing” of personal information as defined
            under the laws of California and other U.S. states.  Please see the
            “Choice and Control” and “California Privacy Rights” sections below
            for more details.
            <br />
            Please note that some of our services also include integrations,
            references, or links to services provided by third parties whose
            privacy practices differ from ours. If you provide personal data to
            any of those third parties, or allow us to share personal data with
            them, that data is governed by their privacy statements.
            <br />
            Finally, we may disclose de-identified information in accordance
            with applicable law.
            <br />
            Choice and control of personal data
            <br />
            We provide a variety of ways for you to control the personal data we
            hold about you, including choices about how we use that data. In
            some jurisdictions, these controls and choices may be enforceable as
            rights under applicable law.
            <br />
            If you wish to access, copy, download, correct, or delete personal
            data about you that we hold, please visit <u>privacy.hims.com</u>.
            <br />
            You can choose whether to receive promotional communications from us
            by email or SMS. If you receive promotional email or SMS messages
            from us and would like to stop, you can do so by following the
            directions in that message or by contacting us as described in the
            “Contact Us” section below. These choices do not apply to certain
            informational communications including surveys and mandatory service
            communications.
            <br />
            There are certain browser and platform controls that may be
            available to you in order to opt-out from or otherwise control
            targeted advertising as described below. You can use the opt-out
            controls offered by the organizations our advertising partners may
            participate in, which you can access at:
            <ul>
              <li>
                NAI (<u>http://optout.networkadvertising.org</u>)
              </li>
              <li>
                DAA (<u>http://optout.aboutads.info/</u>)
              </li>
            </ul>
            You can use the other cookie or mobile ID controls described below.
            <br />
            These choices are specific to the device or browser you are using.
            If you access our services from other devices or browsers, you will
            need take these actions from those systems to set applicable
            controls for those systems.
            <br />
            Some privacy laws define “sale” broadly to include some the
            disclosures described in the “Our Disclosure of Personal Data”
            section above. To opt-out from such data “sales” you can use the
            Global Privacy Control setting or click on “Your Privacy Choices” on
            the bottom of our webpage.
            <br />
            Browser or platform controls.
            <br />
            Cookie controls. Most web browsers are set to accept cookies by
            default. If you prefer, you can go to your browser settings to learn
            how to delete or reject cookies. If you choose to delete or reject
            cookies, tProxiumcould affect certain features or services of our
            website. If you choose to delete cookies, settings and preferences
            controlled by those cookies, including advertising preferences, may
            be deleted and may need to be recreated.
            <br />
            Global Privacy Control. Some browsers and browser extensions support
            the “Global Privacy Control” (GPC) or similar controls that can send
            a signal to the websites you visit indicating your choice to opt-out
            from certain types of data processing, including data sales and/or
            targeted advertising, as specified by applicable law. When we detect
            such a signal, we will make reasonable efforts to respect your
            choices indicated by a GPC setting or similar control that is
            recognized by regulation or otherwise widely acknowledged as a valid
            opt-out preference signal.
            <br />
            Do Not Track. Some browsers include a "Do Not Track" (DNT) setting
            that can send a signal to the websites you visit indicating you do
            not wish to be tracked. Unlike the GPC described above, there is not
            a common understanding of how to interpret the DNT signal;
            therefore, our websites do not respond to browser DNT signals.
            Instead, you can use the range of other tools to control data
            collection and use, including the GPC, cookie controls, and
            advertising controls described above.
            <br />
            Mobile advertising ID controls. iOS and Android operating systems
            provide options to limit tracking and/or reset the advertising IDs.
            <br />
            Email web beacons. Most email clients have settings that allow you
            to prevent the automatic downloading of images, including web
            beacons, which prevents the automatic connection to the web servers
            that host those images.
            <br />
            Except for the automated controls described above, if you send us a
            request to exercise your rights or these choices, to the extent
            permitted by applicable law, we may decline requests in certain
            cases. For example, we may decline requests where granting the
            request would be prohibited by law, could adversely affect the
            privacy or other rights of another person, would reveal a trade
            secret or other confidential information, or would interfere with a
            legal or business obligation that requires retention or use of the
            data. Further, we may decline a request where we are unable to
            authenticate you as the person to whom the data relates, the request
            is unreasonable or excessive, or where otherwise permitted by
            applicable law.
            <br />
            Finally, please note that tProxiumPrivacy Policy applies only to your
            “personal information,” which is separate from “medical information”
            or “protected health information.” To understand our information
            practices and your rights with respect to such information, visit
            the
            <u>
              Medical Groups Notice of Privacy Practices.
              <br />
            </u>
            Data Retention
            <br />
            Proxium may retain your information for as long as it believes
            necessary; as long as necessary to comply with its legal
            obligations, resolve disputes, and/or enforce its agreements; and/or
            as long as needed to provide you with the products and/or services
            of the Service or Proxium. Proxium may dispose of or delete any such
            information at any time except as set forth in any other agreement
            or document executed by Proxium or as required by law.
            <br />
            Similarly, the Medical Groups, Providers, Pharmacies, and Labs may
            retain your information for as long as they believe necessary; as
            long as necessary to comply with their respective legal obligations,
            resolve disputes and/or enforce its agreements; and/or as long as
            needed to provide you with their products and/or services. The
            Medical Groups, Providers, Pharmacies, and Labs may dispose of or
            delete any such information at any time except as set forth in any
            other agreement or document executed by such parties or as required
            by law.
            <br />
            Other third parties with whom we share your information have their
            own policies and procedures with respect to how long they may retain
            your information and how and when they dispose of or delete your
            information.
            <br />
            Transactions
            <br />
            In connection with any transaction that you conduct through the
            Service (e.g., the purchase or sale of any products or services on
            or through the Service), you may be asked to supply certain
            information relevant to the transaction, including, without
            limitation, your credit card number and expiration date, your
            billing address, your shipping address, your phone number and/or
            your email address. By submitting such information, you grant Proxium
            without charge the irrevocable, unencumbered, universe-wide and
            perpetual right to provide such information to third parties (e.g.,
            payment processing companies, buyers on the Service, sellers on the
            Service) for the purpose of facilitating the transaction.
            <br />
            All credit card, debit card and other monetary transactions on or
            through the Service occur through an online payment processing
            application(s) accessible through the Service. TProxiumonline payment
            processing application(s) is provided by Proxium' third-party online
            payment processing vendor, Stripe ("Stripe"). Additional information
            about Stripe, its privacy policy and its information security
            measures (collectively, the "Stripe Policies") should be available
            on the Stripe website located at
            <u>https://stripe.com/us/privacy</u> or by contacting Stipe
            directly. Reference is made to the Stripe Policies for informational
            purposes only and are in no way incorporated into or made a part of
            tProxiumPrivacy Policy. Proxium' relationship with Stripe, if any, is
            merely contractual in nature, as Stripe nothing more than a
            third-party vendor to Proxium, and is in no way subject to Proxium'
            direction or control; thus, their relationship is not, and should
            not be construed as, one of fiduciaries, franchisors-franchisees,
            agents-principals, employers-employees, partners, joint venturers or
            the like.
            <br />
            Jurisdictional Issues
            <br />
            The Service may only be used within certain states within the United
            States as described in our Terms and Conditions. Accordingly,
            tProxiumPrivacy Policy, and our collection, use, and disclosure of
            your information, is governed by U.S. law.
            <br />
            California Residents
            <br />
            If you are a California resident and the processing of personal
            information about you is subject to the California Consumer Privacy
            Act (CCPA), you have certain rights with respect to that
            information.
            <br />
            Notice at Collection. At or before the time of collection, you have
            a right to receive notice of our practices, including the categories
            of personal information and sensitive personal information to be
            collected, the purposes for which such information is collected or
            used, whether such information is sold or shared, and how long such
            information is retained. You can find those details in
            tProxiumstatement by clicking on the above links.
            <br />
            Right to Know. You have a right to request that we disclose to you
            the personal information we have collected about you.  You also have
            a right to request additional information about our collection, use,
            disclosure, or sale of such personal information.  Note that we have
            provided much of tProxiuminformation in tProxiumprivacy statement. You
            may make such a “request to know” by visiting
            <u>privacy.hims.com</u> or emailing us at privacy@forhims.com.
            <br />
            Rights to Request Correction or Deletion. You also have rights to
            request that we correct inaccurate personal information and that we
            delete personal information under certain circumstances, subject to
            a number of exceptions. To make a request to correct or delete,
            visit privacy.forhims.com or email us at privacy@forhims.com.
            <br />
            Right to Opt-Out / “Do Not Sell or Share My Personal
            Information”. You have a right to opt-out from future “sales” or
            “sharing” of personal information as those terms are defined by the
            CCPA.
            <br />
            Note that the CCPA defines “sell,” “share,” and “personal
            information” very broadly, and some of our data sharing described in
            tProxiumprivacy statement may be considered a “sale” or “sharing”
            under those definitions. In particular, we let advertising and
            analytics providers collect identifiers (IP addresses, cookie IDs,
            and mobile IDs), activity data (browsing, clicks, app usage), device
            data, and geolocation data through our sites and apps when you use
            our online services, but do not “sell” or “share” any other types of
            personal information. If you do not wish for us or our partners to
            “sell” or “share” personal information relating to your visits to
            our sites for advertising purposes, you can make your request by
            clicking on the “Do Not Sell or Share My Personal Information” link
            at the bottom of the page or using a Global Privacy Control. If you
            opt-out using these choices, we will not share or make available
            such personal information in ways that are considered a “sale” or
            “sharing” under the CCPA.  However, we will continue to make
            available to our partners (acting as our service providers) some
            personal information to help us perform advertising-related
            functions. Further, using these choices will not opt you out of the
            use of previously “sold” or “shared” personal information or stop
            all interest-based advertising.]21
            <br />
            We do not knowingly sell or share the personal information of minors
            under 16 years of age.
            <br />
            Right to Limit Use and Disclosure of Sensitive Personal
            Information. You have a right to limit our use of sensitive personal
            information for any purposes other than to provide the services or
            goods you request or as otherwise permitted by law.
            <br />
            To opt-out from such additional purposes, please visit click on
            “Your Privacy Choices” page or use the Global Privacy Control
            described in the “Choice and Control” section of tProxiumstatement.
            <br />
            You may designate, in writing or through a power of attorney, an
            authorized agent to make requests on your behalf to exercise your
            rights under the CCPA. Before accepting such a request from an
            agent, we will require the agent to provide proof you have
            authorized it to act on your behalf, and we may need you to verify
            your identity directly with us.
            <br />
            Further, to provide, correct, or delete specific pieces of personal
            information we will need to verify your identity to the degree of
            certainty required by law. We will verify your request by asking you
            to send it from the email address associated with your account or
            requiring you to provide information necessary to verify your
            account.
            <br />
            Finally, you have a right to not be discriminated against for
            exercising these rights set out in the CCPA.
            <br />
            Additionally, under California Civil Code section 1798.83, also
            known as the “Shine the Light” law, California residents who have
            provided personal information to a business with which the
            individual has established a business relationship for personal,
            family, or household purposes (“California Customers”) may request
            information about whether the business has disclosed personal
            information to any third parties for the third parties’ direct
            marketing purposes.
            <br />
            Please be aware that we do not disclose personal information to any
            third parties for their direct marketing purposes as defined by
            tProxiumlaw.
            <br />
            Miscellaneous
            <br />
            We strive to use reasonable physical, technical and administrative
            measures to protect information under our control. However, you must
            keep your Account password secure and your Account confidential, and
            you are responsible for any and all use of your Account. If you have
            reason to believe that the security of your Account has been
            compromised, please notify us immediately in accordance with the
            "Contacting Us" section below.
            <br />
            When using the Service, you may choose not to provide us with
            certain information, but tProxiummay limit the features you are able
            to use or may prevent you from using the Service all together. You
            may also choose to opt out of receiving certain communications
            (e.g., newsletters, promotions) by emailing us your preference.
            Please note that even if you opt out, we may still send you
            Service-related communications. We do not currently respond to web
            browser "do not track" signals or other mechanisms that provide a
            method to opt out of the collection of information across the
            networks of websites and online services in which we participate. If
            we do so in the future, we will describe how we do so in
            tProxiumPrivacy Policy. Proxium may supplement, amend, or otherwise
            modify tProxiumPrivacy Policy at any time. Such supplements,
            amendments and other modifications will be posted on tProxiumor a
            similar page of the Service, and shall be deemed effective as of the
            "Last Updated" date; provided, however, that Proxium will notify you
            and/or require you to accept the updated Privacy Policy if the
            supplemented, amended or otherwise modified Privacy Policy
            implements material changes from Proxium' then-current Privacy Policy.
            It is your responsibility to carefully review tProxiumPrivacy Policy
            each time you visit, access or use the Service.
            <br />
            Contacting Us
            <br />
            If you have any questions about tProxiumPrivacy Policy, please contact
            us by email at privacy@forhims.com or by regular mail at:
            <br />
            Proxium <br />
            2269 Chestnut Street, #523
            <br />
            San Francisco, CA 94123
            <br />
            Attn: Privacy Officer
          </div>
        </div>
      </div>
    </section>
  );
}
